function isOutOfView(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.bottom < 0 ||
        rect.top > window.innerHeight ||
        rect.right < 0 ||
        rect.left > window.innerWidth
    );
}

(function () {
    function init() {
        const progressBar = document.querySelector('.collection-progress');
        const gridItem = document.querySelectorAll('.grid-item');
        const pagination = document.querySelectorAll('.pagination-pages .pagination');
    
        const prevButton = document.getElementById('asset-prev-button');
        const nextButton = document.getElementById('asset-next-button');
        const paginationPrev = document.getElementById('pagination-prev');
        const paginationNext = document.getElementById('pagination-next');
        const paginationDotsPrev = document.getElementById('pagination-dots-prev');
        const paginationDotsNext = document.getElementById('pagination-dots-next');

        if (!progressBar || !prevButton || !nextButton || !paginationPrev || !paginationNext || !paginationDotsPrev || !paginationDotsNext) {
            return;
        }
        
        prevButton.disabled = true;
        paginationPrev.disabled = true;
        
        const totalPages = progressBar.total;
        let currentPage = 1;
        
        // Event Listeners
        [prevButton, paginationPrev].forEach(button => {
            button.addEventListener('click', () => {
                currentPage -= 1;
                if (currentPage < 1) currentPage = 1;
                progressBar.value = currentPage;
        
                showActiveContent();
                setPagination(currentPage, totalPages);
            });
        });
        
        [nextButton, paginationNext].forEach(button => {
            button.addEventListener('click', () => {
                currentPage += 1;
                if (currentPage > totalPages) currentPage = totalPages;
                progressBar.value = currentPage;
        
                showActiveContent();
                setPagination(currentPage, totalPages);
            });
        });
        
        pagination.forEach(button => {
            button.addEventListener('click', () => {
                currentPage = parseInt(button.id.replace("pagination-page-", ""), 10);
                progressBar.value = currentPage;
        
                showActiveContent();
                setPagination(currentPage, totalPages);
            });
        });
       
        // Functions
        function showActiveContent(){
            gridItem.forEach(content => content.setAttribute('hidden', true));
            document.querySelectorAll(`.grid-item.page-${currentPage}`).forEach(content => content.removeAttribute('hidden'));
        }
            
        function setPagination(currentPage, totalPages){
            const isMobile = window.innerWidth <= 768;
            const maxVisiblePages = isMobile ? 5 : 10;
            const midSize = maxVisiblePages - 2;
            const half = Math.floor(midSize / 2);
    
            let startPage = 2;
            let endPage = totalPages - 1;
    
            if (totalPages > maxVisiblePages) {
                if (currentPage <= half + 1) {
                    endPage = midSize + 1;
                    paginationDotsPrev.hidden = true;
                    paginationDotsNext.hidden = false;
                } else if (currentPage >= totalPages - half) {
                    startPage = totalPages - midSize;
                    paginationDotsPrev.hidden = false;
                    paginationDotsNext.hidden = true;
                } else {
                    startPage = currentPage - half;
                    endPage = currentPage + half;
                    paginationDotsPrev.hidden = false;
                    paginationDotsNext.hidden = false;
                }
    
                startPage = Math.max(2, startPage);
                endPage = Math.min(totalPages - 1, endPage);
            } else {
                paginationDotsPrev.hidden = true;
                paginationDotsNext.hidden = true;
            }
    
            pagination.forEach(button => {
                const pageNum = parseInt(button.id.replace("pagination-page-", ""), 10);
                
                // Skip buttons that don't have valid page numbers
                if (isNaN(pageNum)) {
                    console.warn('Invalid pagination button ID:', button.id);
                    return;
                }
                
                const isEdge = pageNum === 1 || pageNum === totalPages;
                const isInRange = pageNum >= startPage && pageNum <= endPage;
    
                button.hidden = !(isEdge || isInRange);
                button.classList.toggle('active', pageNum === currentPage);
            });
    
            // Prev/Next button states
            const atFirstPage = currentPage <= 1;
            const atLastPage = currentPage >= totalPages;
    
            prevButton.variant = atFirstPage ? 'default' : 'primary';
            prevButton.disabled = paginationPrev.disabled = atFirstPage;
            nextButton.disabled = paginationNext.disabled = atLastPage;
    
            // Ellipsis visibility
            if (!paginationDotsPrev.hidden && startPage === 2) {
                paginationDotsPrev.hidden = true;
            }
            if (!paginationDotsNext.hidden && endPage === totalPages - 1) {
                paginationDotsNext.hidden = true;
            }

            // Scroll into view if needed
            if (isOutOfView(document.querySelector('.collection-navigation'))) {
                document.querySelector('.collection-navigation')?.scrollIntoView({ behavior: 'instant'});
            }
        }
        
        // Set pagination on load
        setPagination(currentPage, totalPages);
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();